// Action balance data. Types live in `types/actions.ts`.
import { ACTION_KINDS } from "../types/actions.js";
/** Human-readable label per core action — the single source of truth for action
 * names shown in the UI (e.g. the turn action bar). Keyed by `ActionKind`, so
 * adding a core action is a compile error until it has a label. */
export const ACTION_LABELS = {
    construct_building: "Construct Building",
    construct_bridge: "Construct Bridge",
    implement_fortress: "Implement Fortress",
    aim_barracks: "Aim Barracks",
    cycle_market: "Cycle Market",
};
/** One-line description per core action, for tooltips / help text. */
export const ACTION_DESCRIPTIONS = {
    construct_building: "Place a Scout, Barracks, or Mine on a node.",
    construct_bridge: "Build a Bridge on a path between two nodes (spans a chasm or a connected path).",
    implement_fortress: "Realise a face-up Fortress card's pattern with your buildings.",
    aim_barracks: "Aim an unaimed Barracks: attack an enemy building in range, or defend a building. Committed until the round ends.",
    cycle_market: "Swap any face-up Fortresses out of one market row — regular or win, not both — 1 Food each.",
};
export const ACTION_CONFIG = {
    kinds: ACTION_KINDS,
    labels: ACTION_LABELS,
    descriptions: ACTION_DESCRIPTIONS,
};
//# sourceMappingURL=actions.js.map